export const documentsEndpoint = {
  delete: 'api/Documents/Delete',
  getById: 'api/Documents/',
  AdminGetAll: 'api/Documents/AdminGetAll',
  insert: 'api/Documents/Insert',
  filter: 'api/Documents/Filter',
  GetAllDocumentsCategory: 'api/DocumentCategory/GetAll',
  InsetDocumentsCategory: 'api/DocumentCategory/Insert',
  AdminFilter: 'api/Documents/AdminFilter',
  Update: 'api/Documents/Update',
  insertComment: 'api/Comment/Insert',
  aiAssistantGetText: 'api/Documents/AiAssistantGetText',
};
